<template>  
    <section class="hero is-medium is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div id="navbarMenu" class="navbar-menu">
              <div class="navbar-end">
                <span class="navbar-item">
                  <a href="https://www.linkedin.com/in/philipsimonelliott/">
                    <span class="icon">
                      <i class="fa fa-linkedin"></i>
                    </span>
                  </a>
                </span>                
                <span class="navbar-item">
                  <a href="https://github.com/fyllepo" target="_blank">
                    <span class="icon">
                      <i class="fa fa-github"></i>
                    </span>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>      
      <div class="hero-body">
        <div class="hero-filter js-hero-filter"></div>       
        <video autoplay loop muted class="hero-video">
          <source src="/static/video/webm/love-coding.webm" type="video/webm" />
          <source src="/static/video/mp4/love-coding.mp4" type="video/mp4" />
          <source src="/static/video/ogv/love-coding.ogv" type="video/ogg" />            
        </video>

        <div class="hero-body__content columns is-vcentered">
          <div class="container has-text-centered">
            <h1 class="title">
              Hey I'm Phil, a well-rounded full-stack developer from Leeds.
            </h1>
            <h2 class="subtitle">
              <strong>JavaScript?</strong> Check. <strong>VueJS?</strong> No problem. <strong>PHP?</strong> It's my middle name!
            </h2>
          </div>           
        </div>       
      </div>

      <a href="https://www.linkedin.com/in/philipsimonelliott/" class="hero__get-in-touch">
        Get in touch
      </a>
    </section>
</template>

<script>
  export default {
    name: 'page-header' 
  }
</script>


// WEBPACK FOOTER //
// src/components/PageHeader.vue